<template>
  <div>
    <top-part />
    <div class="my-content">
      <home-grid :menuList="authorityInfoWx"></home-grid>
      <home-grid :menuList="getAllMenuAPPattr"></home-grid>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import topPart from "../../components/topPart";
import homeGrid from "./components/grid";
import interfaceAttr from "../../centralControl/utils/interfaceAttr";
export default {
  components: {
    topPart,
    homeGrid
  },
  data() {
    return {
      authorityInfoWx: [
        {
          menu_name: "常用服务",
          list: []
        }
      ],
      stusConfig: "", //获取配置
      itemMore: [
        {
          file_url: require("../../assets/images/ic-add.png"),
          menu_name: "编辑",
          menu_href: "/serviceHallEdit",
          border: true
        }
      ], //更多按钮
      getUserIdMenuAPPAttr: [], //接收用户菜单数据
      getAllMenuAPPattr: [], //获取全部菜单
      interAttrs: ["getUserIdMenuAPP", "getAllMenuAPP"], //需要请求的接口名称
      currentLoginInfo: {}
    };
  },
  watch: {
    getUserIdMenuAPPAttr(newName, oldName) {
      this.authorityInfoWx[0].list = newName;
      this.authorityInfoWx[0].list = [
        ...this.authorityInfoWx[0].list,
        ...this.itemMore
      ];
    }
  },
  created() {
    const loginInfo = localStorage.getItem("loginInfo");
    this.currentLoginInfo = loginInfo ? JSON.parse(loginInfo).identity : {};
    this.stusConfig = this.centralControl.utils.getConfig(
      this.centralControl.config,
      ["allItem", "manageErea"]
    );
    this.init();
  },
  methods: {
    getAllMenuAPP(data) {
      this.handleList(data);
    },
    handleList(datas) {
      for (let items of datas) {
        let that = this;
        var data = items.list;
        for (var a = 0; a < data.length; a++) {
          var item = data[a];
          if (that.stusConfig[item.menu_code]) {
            let flagStatus =
              that.stusConfig[item.menu_code].visible.indexOf(
                this.currentLoginInfo
              ) == -1;
            if (flagStatus) {
              data.splice(a, 1);
              a--;
            }
          }
        }
      }
      this.getAllMenuAPPattr = datas;
    },
    getUserIdMenuAPP(data) {
      let that = this;
      for (var a = 0; a < data.length; a++) {
        var item = data[a];
        if (that.stusConfig[item.menu_code]) {
          let flagStatus =
            that.stusConfig[item.menu_code].visible.indexOf(
              that.currentLoginInfo
            ) == -1;
          if (flagStatus) {
            data.splice(a, 1);
            a--;
          }
        }
      }
      this.getUserIdMenuAPPAttr = data;
    },
    init() {
      this.centralControl.utils.eachIndexattr(
        this,
        this.interAttrs,
        interfaceAttr
      );
    }
  }
};
</script>
<style lang="stylus" type="stylesheet/stylus" scoped>
@import '../../assets/stylus/index.styl';
@import '../../assets/stylus/reset.css';
</style>